module.exports = __webpack_public_path__ + "movie.jpg?80a1b8109ad29a28d54c885dcdf12b5f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/movie.jpg
// module id = 22
// module chunks = 0